import { isNull } from 'utils/tsHelpers';
import { validateRelativeDate as hasRelativeDateError } from 'utils/validateDate';

export const getIsRelativeDate = (date: string | null) =>
  isNull(date) ? false : !hasRelativeDateError(date);
